angular.module('examManagement').factory('ExamPresort', ['$resource', function($resource) {
  return $resource('/api/exams/:examId/presort', {examId: '@exam_id'}, {
    apply: {method: 'POST', isArray: false}
  });
}]);
